import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'components/misc'
import { get } from 'lodash'

import { modal } from 'redux/modules/app'
import { apiOrganizations, apiAssessors } from 'helpers/decorators/api'
import { form, permissions } from 'helpers/decorators'
import { inviteValidation } from 'models/assessors'
import { organizationDropdownSelector } from 'redux/selectors/organizations'
import InviteNewAssessorModal from '../../../../components/modals/assessors/InviteNewAssessorModal'
import modals from '../../../../constants/modals'

@permissions()
@apiOrganizations({
  filter: 'awardUnits'
})
@apiAssessors()
@form({
  form: 'invite-new-assessor-form',
  validate: inviteValidation
})
@connect(
  state => ({
    activeOrganization: state.auth.organization,
    awardUnits: organizationDropdownSelector(state)
  }),
  { modal }
)
class AssessorInvite extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    inviteNewAssessor: PropTypes.func.isRequired,
    getOrganizations: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    awardUnits: PropTypes.array,
    checkAssessorEmailAvailability: PropTypes.func.isRequired
  }

  static defaultProps = {
    params: {}
  }

  state = {
    isLoading: null
  }

  handleOpenModal = () => {
      this.props.modal(modals.INVITE_NEW_ASSESSOR_MODAL)
  }

  render() {
    const {
      inviteNewAssessor,
      activeOrganization,
      checkAssessorEmailAvailability,
      permissions: appPermissions
    } = this.props

    const { isLoading } = this.state

    return (
      <div>
        <div className="row">
          <div className="col-xs-12 text--right">
            {appPermissions.isLeader && <Button
              className="base-margin--bottom"
              intlKey="button.invite_assessor"
              onClick={this.handleOpenModal}
              isLoading={isLoading}
            >
              Invite assessor
            </Button>}
          </div>
        </div>
        <InviteNewAssessorModal
            modalId={modals.INVITE_NEW_ASSESSOR_MODAL}
            orgId={get(activeOrganization, 'id')}
            onApprove={inviteNewAssessor}
            checkAssessorEmailAvailability={checkAssessorEmailAvailability}
        />
      </div>
    )
  }
}

export default AssessorInvite
